import React, { useMemo } from 'react';

const PaymentProviderContext = React.createContext({
  shouldOpenByPopup: false,
});

export const usePaymentHandler = () => React.useContext(PaymentProviderContext);

const PaymentProviderProvider = ({ children, shouldOpenByPopup }) => {
  const value = useMemo(() => {
    return {
      shouldOpenByPopup,
    };
  }, [shouldOpenByPopup]);

  return (
    <PaymentProviderContext.Provider value={value}>{children}</PaymentProviderContext.Provider>
  );
};

export default PaymentProviderProvider;
